// หน้าที่ฝัง Inbox Center ตรง ๆ หน้าเดียวไม่มีแท็บ (Content › Calendar, Analytics › Facebook Inbox)
import type { Brand } from "@contracts/api";
import { isLinePage } from "@features/inbox/api/inbox-api";
import { NoPageAccess, NotConnected } from "../components/embed-empty";
import { EmbedHead } from "../components/embed-head";
import { inboxUrl } from "../lib/inbox-embed";

type Props = {
  brand: Brand;
  /** ไฟล์หน้าฝั่ง Inbox Center เช่น comments.html / analytics.html */
  page: string;
  title: string;
  crumb: string;
};

export function FbEmbedPage({ brand, page, title, crumb }: Props) {
  const all = brand.pageIds ?? [];
  const fbIds = all.filter((id) => !isLinePage(id));

  return (
    <>
      <EmbedHead crumb={`${brand.name} / ${crumb}`} title={title} />
      <div className="embed-frame">
        {/* ไม่ได้ล็อกเพจไว้ = ไม่มีเพจให้ดู ไม่ใช่ดูได้ทุกเพจ — ดู NoPageAccess */}
        {!all.length ? (
          <NoPageAccess />
        ) : fbIds.length ? (
          <iframe src={inboxUrl(page, fbIds)} title={title} allow="clipboard-write" />
        ) : (
          <NotConnected what="เพจ Facebook" />
        )}
      </div>
    </>
  );
}
